/**
 * v20181028
 */
(function(define, window) {
  define(['jquery', 'app.core.min'], function($, app) {
    'use strict';

    return function() {
          $(window).scroll(function(){
      var sticky = $('.stickyNav'),
          scroll = $(window).scrollTop();

      if (scroll >= 0) sticky.addClass('fixedNav');
      else sticky.removeClass('fixedNav');
    });

    };
  });
}(define, window));
